"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFinancialCovenantConfig = exports.getFinancialCovenantQueryResultVariablesAndErrors = void 0;
const athena_utilities_1 = require("@finley-technologies/athena-utilities");
const common_1 = require("@finley-technologies/common");
const finley_date_1 = require("@finley-technologies/finley-date");
const covenantPostgresQuery_1 = require("../../covenantPostgresQuery");
const intermediateField = __importStar(require("./intermediateField"));
/**
 * This doesn't include intermediate fields validations
 */
const getFinancialCovenantQueryResultVariablesAndErrors = (params) => {
    const { triggerDates, globalRecurringDateConfigs, athenaQueries, athenaRecurringQueries, postgresQueries, } = params.config;
    const errors = [];
    // *** Trigger Date Validations ***
    try {
        finley_date_1.recurringDate.createDateListFromConfig(triggerDates);
    }
    catch (err) {
        const errorMessage = `Error during createDateListFromConfig with triggerDate config: ${JSON.stringify(triggerDates)}. Message: ${(0, common_1.getErrorMessage)(err)}`;
        errors.push(errorMessage);
    }
    const queryResultVariables = [];
    // *** Global Recurring Date Validations ***
    const { queryResultVariables: globalRecurringDateVariables, errors: globalRecurringDateErrors, } = finley_date_1.recurringDate.validateGlobalRecurringDateConfigs({
        globalRecurringDateConfigs,
    });
    globalRecurringDateVariables.forEach((variable) => queryResultVariables.push(variable));
    globalRecurringDateErrors.forEach((error) => errors.push(error));
    // *** Athena Validations ***
    const { errors: athenaErrors, queryResultVariables: athenaQueryResultVariables, } = athena_utilities_1.validate.validateAthenaQueries(athenaQueries);
    athenaQueryResultVariables.forEach((variable) => queryResultVariables.push(variable));
    athenaErrors.forEach((err) => errors.push(err));
    // *** Athena Recurring Query Validations ***
    const { queryResultVariables: athenaRecurringQueryResultVariables, errors: athenaRecurringQueryErrors, } = athena_utilities_1.validate.validateAthenaRecurringQueries({
        athenaRecurringQueries,
        globalRecurringDateConfigs,
    });
    athenaRecurringQueryResultVariables.forEach((variable) => queryResultVariables.push(variable));
    athenaRecurringQueryErrors.forEach((error) => errors.push(error));
    // *** Postgres Queries ***
    const postgresResults = (0, covenantPostgresQuery_1.validatePostgresQueries)({ postgresQueries });
    postgresResults.queryResultVariables.forEach((variable) => queryResultVariables.push(variable));
    postgresResults.errors.forEach((err) => errors.push(err));
    // *** Check Duplicate Fields ***
    const variableSet = new Set();
    queryResultVariables.forEach((queryResultVariable) => {
        if (variableSet.has(queryResultVariable)) {
            errors.push(`Duplicate query result variable: ${queryResultVariable}`);
        }
        else {
            variableSet.add(queryResultVariable);
        }
    });
    return { queryResultVariables, errors };
};
exports.getFinancialCovenantQueryResultVariablesAndErrors = getFinancialCovenantQueryResultVariablesAndErrors;
/**
 * Validates a financial covenant config
 * This method expects triggerDate to already have been attached to the config.
 */
const validateFinancialCovenantConfig = (params) => {
    const errors = [];
    // *** Pre-Intermediate Field Validations ***
    const preIntermediateResults = (0, exports.getFinancialCovenantQueryResultVariablesAndErrors)(params);
    preIntermediateResults.errors.forEach((err) => errors.push(err));
    // *** Intermediate Field Validations ***
    const intermediateValidate = intermediateField.validateIntermediateFields({
        intermediateFields: params.config.intermediateFields,
        queryResultVariables: preIntermediateResults.queryResultVariables,
    });
    intermediateValidate.errors.forEach((err) => errors.push(err));
    return { errors };
};
exports.validateFinancialCovenantConfig = validateFinancialCovenantConfig;
//# sourceMappingURL=config.js.map